import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useChecklistState = () => React.useContext(Context)
export const useChecklist = () => useChecklistState()?.checklist

const QUERY = gql`
  query Checklist($id: ID) {
    checklist(id: $id, filter: { includeDeleted: true, includeDisabled: true, ignoreSegments: true }) {
      id
      name
      usages
      insertedAt
      updatedAt
      deleted
      enabled
      type {
        id
        name
      }
    }
  }
`

const ChecklistsLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: checklistsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChecklistsLoader
